import {Link} from 'react-router-dom';
import {useLang} from '../../hooks/useLang';
import {buildPath} from '../../services/language';

const AppStrip = ({apps}) => {
  const {lang, t} = useLang();

  return (
    <ul className="app-strip" aria-labelledby="projects-title">
      {apps.map((app, i) => {
        const name = t(`apps.${app.id}.name`);
        const img = (
          <img
            className="app-strip__icon"
            src={app.icon.src}
            srcSet={`${app.icon.src2x} 2x`}
            width="72"
            height="72"
            alt=""
          />
        );

        return (
          <li key={app.id} className="app-strip__item" style={{'--i': i}}>
            {app.status === 'active' ? (
              <Link
                className="app-strip__link"
                to={buildPath(lang, app.page)}
                onClick={() => window.scrollTo(0, 0)}
                aria-label={name}
              >
                {img}
              </Link>
            ) : (
              <span className="app-strip__link" role="img" aria-label={name}>
                {img}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default AppStrip;
